import AppDetail from './components/Detail/AppDetail.vue'
import Solutions from "./components/Solutions.vue";
//  import ErrorComponent from "./components/Error.vue";

export default [
    { path: '/', component: Solutions, sensitive:true, strict:true},
    { path: '/apps/detail/:id', component: AppDetail, sensitive:true, strict:true},
    { path: '/allSolution', component:Solutions, sensitive:true, strict:true},
    { path: '/*', redirect:'/'}
];

